.player {
  position: relative;

  iframe,
  video {
    border: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    &[aria-hidden="true"] {
      display: none;
    }
  }
}
